@import (reference) '../../../../../../constants/spacing.module.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';

.container {
  display: flex;
  flex-direction: column;
  gap: @space-24;
  text-align: left;
}

.fileInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-16;
  padding: @space-16;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  background-color: var(--grey-50);

  @media @mobile, @ultramobile {
    flex-direction: column;
    align-items: flex-start;
  }
}

.fileDisplay {
  display: flex;
  align-items: center;
  gap: @space-12;
  flex: 1;
  min-width: 0;
}

.fileIcon {
  color: var(--grey-600);
  font-size: 20px;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.fileName {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.viewOrdersLink {
  display: flex;
  align-items: center;
  gap: @space-4;
  padding: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.importAnotherLink {
  display: flex;
  align-items: center;
  gap: @space-4;
  padding: 0;
  align-self: flex-start;
}

.uploadIcon {
  color: var(--blue-500);
  font-size: 14px;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
}
